module.exports = __webpack_public_path__ + "static/2_1_search-2_PT-d4295a5a65c87d7f30afdd8cc2d53434.svg";